import styled from 'styled-components';

export const StyleFormWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    @media (max-width: 768px) {
        flex-direction: column;
        width: 90%;
        justify-content: center;
    }
`;
